module.exports = __webpack_public_path__ + "static/media/SchoolCosLearnCreatorDemo.1163dc1c.mp4";